//#region Utils
import ABSOLUTE_PATHS from "routes/utils/absolutePaths";
//#endregion

export const CREATE_EVENT_DROPDOWN_OPTIONS = {
    text: "Crear evento",
    items: [
        { 
            path: ABSOLUTE_PATHS.CREATE_EVENT_MANUAL_LOADING, 
            text: "Carga manual" 
        },
        { 
            path: ABSOLUTE_PATHS.CREATE_EVENT_MASSIVE_LOADING, 
            text: "Carga masiva" 
        }
    ]
};